// extracted by mini-css-extract-plugin
export default {"cupra":"SecondaryButton_cupra__YPE-T","tyc":"SecondaryButton_tyc__vNJCH"};